import Axios from "../../../networking/interceptor";
import { save_fcm_token } from "../../../networking/urlEndPoints";

/**
 * Sends the FCM device token to the backend so it can target this device for push notifications
 * (e.g. video call alerts). Call when the user enables notifications or when the token is refreshed.
 * @param {string} fcmToken - The FCM registration token from Firebase
 * @returns {Promise<boolean>} - True if save succeeded, false otherwise
 */
export const saveFcmTokenToBackend = async (fcmToken) => {
  if (!fcmToken || typeof fcmToken !== "string") return false;
  try {
    await Axios.post(save_fcm_token, { fcm_token: fcmToken });
    return true;
  } catch (err) {
    console.warn("Could not save FCM token to backend:", err?.response?.status || err.message);
    return false;
  }
};
